module.exports = __webpack_public_path__ + "img/database.613a9c9c.png";